import CreatableSelect from 'react-select/creatable';
import useSWR from 'swr';

import { getAutocompleteDeliveryCategories } from '@services/stock';
import { useShop } from '@services/ShopProvider';

import styles from './InventoryFilters.module.scss';

const DeliveryCategoriesSelect = ({ onChange, value = undefined }) => {
	const { shop, organisation } = useShop();
	const { data: options } = useSWR(['autocomplete-delivery-categories', shop?.id || organisation.id], () =>
		getAutocompleteDeliveryCategories(organisation.id, shop?.id)
	);

	return (
		<CreatableSelect
			className={styles.select}
			isMulti
			isClearable={true}
			placeholder={'Search for a menu cateory...'}
			value={value ? value.map((value) => ({ value, label: value })) : undefined}
			noOptionsMessage={() => 'No matches'}
			formatCreateLabel={(inputValue) => `Use: "${inputValue}"`}
			onChange={(value) => onChange(value.map((item) => item.value))}
			options={options}
			isLoading={!options}
			components={{ IndicatorSeparator: () => null }}
		/>
	);
};

export default DeliveryCategoriesSelect;
